var map = {
	"./AVC_Main/AVCMain": [
		"./src/layouts/AVC_Main/AVCMain.js"
	],
	"./AVC_Main/AVCMain.js": [
		"./src/layouts/AVC_Main/AVCMain.js"
	],
	"./AVC_Main/components/footerDashboard/FooterDashboard": [
		"./src/layouts/AVC_Main/components/footerDashboard/FooterDashboard.jsx"
	],
	"./AVC_Main/components/footerDashboard/FooterDashboard.jsx": [
		"./src/layouts/AVC_Main/components/footerDashboard/FooterDashboard.jsx"
	],
	"./AVC_Main/components/footerDashboard/style": [
		"./src/layouts/AVC_Main/components/footerDashboard/style.js"
	],
	"./AVC_Main/components/footerDashboard/style.js": [
		"./src/layouts/AVC_Main/components/footerDashboard/style.js"
	],
	"./AVC_Main/components/headerDashboard/HeaderDashboard": [
		"./src/layouts/AVC_Main/components/headerDashboard/HeaderDashboard.jsx"
	],
	"./AVC_Main/components/headerDashboard/HeaderDashboard.jsx": [
		"./src/layouts/AVC_Main/components/headerDashboard/HeaderDashboard.jsx"
	],
	"./AVC_Main/components/headerDashboard/items-list/SiteListItem": [
		"./src/layouts/AVC_Main/components/headerDashboard/items-list/SiteListItem.jsx"
	],
	"./AVC_Main/components/headerDashboard/items-list/SiteListItem.jsx": [
		"./src/layouts/AVC_Main/components/headerDashboard/items-list/SiteListItem.jsx"
	],
	"./AVC_Main/components/headerDashboard/items-list/style": [
		"./src/layouts/AVC_Main/components/headerDashboard/items-list/style.js",
		"src_layouts_AVC_Main_components_headerDashboard_items-list_style_js"
	],
	"./AVC_Main/components/headerDashboard/items-list/style.js": [
		"./src/layouts/AVC_Main/components/headerDashboard/items-list/style.js",
		"src_layouts_AVC_Main_components_headerDashboard_items-list_style_js"
	],
	"./AVC_Main/components/headerDashboard/style": [
		"./src/layouts/AVC_Main/components/headerDashboard/style.js"
	],
	"./AVC_Main/components/headerDashboard/style.js": [
		"./src/layouts/AVC_Main/components/headerDashboard/style.js"
	],
	"./AVC_Main/components/sidebarDashboard/MenuStyle": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/MenuStyle.js"
	],
	"./AVC_Main/components/sidebarDashboard/MenuStyle.js": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/MenuStyle.js"
	],
	"./AVC_Main/components/sidebarDashboard/SidebarDashboard": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/SidebarDashboard.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/SidebarDashboard.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/SidebarDashboard.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/aquaticSection/AquaticModalSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/aquaticSection/AquaticModalSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/aquaticSection/AquaticModalSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/aquaticSection/AquaticModalSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/aquaticSection/AquaticSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/aquaticSection/AquaticSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/aquaticSection/AquaticSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/aquaticSection/AquaticSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/chainSection/ChainModalSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/chainSection/ChainModalSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/chainSection/ChainModalSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/chainSection/ChainModalSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/chainSection/ChainSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/chainSection/ChainSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/chainSection/ChainSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/chainSection/ChainSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/ProPopUpSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/ProPopUpSection.jsx",
		"src_layouts_AVC_Main_components_sidebarDashboard_professionalSection_ProPopUpSection_jsx"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/ProPopUpSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/ProPopUpSection.jsx",
		"src_layouts_AVC_Main_components_sidebarDashboard_professionalSection_ProPopUpSection_jsx"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalItem": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalItem.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalItem.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalItem.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalSidebarSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalSidebarSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalSidebarSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/ProfessionalSidebarSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/style": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/style.js"
	],
	"./AVC_Main/components/sidebarDashboard/professionalSection/style.js": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/professionalSection/style.js"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/BioMenu": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/BioMenu.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/BioMenu.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/BioMenu.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/SystemSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/SystemSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/SystemSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/SystemSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoLegalDialog": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoLegalDialog.jsx",
		"vendors-node_modules_react-date-object_calendars_persian_js-node_modules_react-date-object_lo-8c9787",
		"vendors-node_modules_react-multi-date-picker_plugins_time_picker_js",
		"src_components_form_index_js",
		"src_layouts_AVC_Main_components_sidebarDashboard_systemSection_editprofile_EditInfoLegalDialo-6cf458"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoLegalDialog.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoLegalDialog.jsx",
		"vendors-node_modules_react-date-object_calendars_persian_js-node_modules_react-date-object_lo-8c9787",
		"vendors-node_modules_react-multi-date-picker_plugins_time_picker_js",
		"src_components_form_index_js",
		"src_layouts_AVC_Main_components_sidebarDashboard_systemSection_editprofile_EditInfoLegalDialo-6cf458"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoRealDialog": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoRealDialog.jsx",
		"vendors-node_modules_react-date-object_calendars_persian_js-node_modules_react-date-object_lo-8c9787",
		"vendors-node_modules_react-multi-date-picker_plugins_time_picker_js",
		"src_components_form_index_js",
		"src_layouts_AVC_Main_components_sidebarDashboard_systemSection_editprofile_EditInfoRealDialog-3d3182"
	],
	"./AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoRealDialog.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/systemSection/editprofile/EditInfoRealDialog.jsx",
		"vendors-node_modules_react-date-object_calendars_persian_js-node_modules_react-date-object_lo-8c9787",
		"vendors-node_modules_react-multi-date-picker_plugins_time_picker_js",
		"src_components_form_index_js",
		"src_layouts_AVC_Main_components_sidebarDashboard_systemSection_editprofile_EditInfoRealDialog-3d3182"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/TraceabilitySection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/TraceabilitySection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/TraceabilitySection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/TraceabilitySection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTextField": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTextField.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTextField.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTextField.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTracingSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTracingSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTracingSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingTracingSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingValidation": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingValidation.js"
	],
	"./AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingValidation.js": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/traceabilitySection/product-tracking/TrackingValidation.js"
	],
	"./AVC_Main/components/sidebarDashboard/usefulSection/UsefulSection": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/usefulSection/UsefulSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/usefulSection/UsefulSection.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/usefulSection/UsefulSection.jsx"
	],
	"./AVC_Main/components/sidebarDashboard/usefulSection/ai/AI": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/usefulSection/ai/AI.jsx",
		"src_layouts_AVC_Main_components_sidebarDashboard_usefulSection_ai_AI_jsx"
	],
	"./AVC_Main/components/sidebarDashboard/usefulSection/ai/AI.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/usefulSection/ai/AI.jsx",
		"src_layouts_AVC_Main_components_sidebarDashboard_usefulSection_ai_AI_jsx"
	],
	"./AVC_Main/components/sidebarDashboard/usefulSection/notification/NotifAccardion": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/usefulSection/notification/NotifAccardion.jsx",
		"src_layouts_AVC_Main_components_sidebarDashboard_usefulSection_notification_NotifAccardion_jsx"
	],
	"./AVC_Main/components/sidebarDashboard/usefulSection/notification/NotifAccardion.jsx": [
		"./src/layouts/AVC_Main/components/sidebarDashboard/usefulSection/notification/NotifAccardion.jsx",
		"src_layouts_AVC_Main_components_sidebarDashboard_usefulSection_notification_NotifAccardion_jsx"
	],
	"./AVC_Main/config/MainPermissionListConfig": [
		"./src/layouts/AVC_Main/config/MainPermissionListConfig.js"
	],
	"./AVC_Main/config/MainPermissionListConfig.js": [
		"./src/layouts/AVC_Main/config/MainPermissionListConfig.js"
	],
	"./AVC_Main/services/footerDashboard/Timer": [
		"./src/layouts/AVC_Main/services/footerDashboard/Timer.js"
	],
	"./AVC_Main/services/footerDashboard/Timer.js": [
		"./src/layouts/AVC_Main/services/footerDashboard/Timer.js"
	],
	"./AVC_Main/services/footerDashboard/useGetActiveSubscription": [
		"./src/layouts/AVC_Main/services/footerDashboard/useGetActiveSubscription.js"
	],
	"./AVC_Main/services/footerDashboard/useGetActiveSubscription.js": [
		"./src/layouts/AVC_Main/services/footerDashboard/useGetActiveSubscription.js"
	],
	"./AVC_Main/services/headerDashboard/useActiveSiteList": [
		"./src/layouts/AVC_Main/services/headerDashboard/useActiveSiteList.js"
	],
	"./AVC_Main/services/headerDashboard/useActiveSiteList.js": [
		"./src/layouts/AVC_Main/services/headerDashboard/useActiveSiteList.js"
	],
	"./AVC_Main/services/sidebarDashboard/systemSection/useLogout": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/systemSection/useLogout.js"
	],
	"./AVC_Main/services/sidebarDashboard/systemSection/useLogout.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/systemSection/useLogout.js"
	],
	"./AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeLegal": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeLegal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_systemSection_useUpdateMeLegal_js"
	],
	"./AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeLegal.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeLegal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_systemSection_useUpdateMeLegal_js"
	],
	"./AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeReal": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeReal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_systemSection_useUpdateMeReal_js"
	],
	"./AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeReal.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/systemSection/useUpdateMeReal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_systemSection_useUpdateMeReal_js"
	],
	"./AVC_Main/services/sidebarDashboard/useGetLegal": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/useGetLegal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_useGetLegal_js"
	],
	"./AVC_Main/services/sidebarDashboard/useGetLegal.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/useGetLegal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_useGetLegal_js"
	],
	"./AVC_Main/services/sidebarDashboard/useGetReal": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/useGetReal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_useGetReal_js"
	],
	"./AVC_Main/services/sidebarDashboard/useGetReal.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/useGetReal.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_useGetReal_js"
	],
	"./AVC_Main/services/sidebarDashboard/useGetWebMenuList": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/useGetWebMenuList.js"
	],
	"./AVC_Main/services/sidebarDashboard/useGetWebMenuList.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/useGetWebMenuList.js"
	],
	"./AVC_Main/services/sidebarDashboard/usefulSection/useGetCheckNewMessage": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/usefulSection/useGetCheckNewMessage.js"
	],
	"./AVC_Main/services/sidebarDashboard/usefulSection/useGetCheckNewMessage.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/usefulSection/useGetCheckNewMessage.js"
	],
	"./AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationCount": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationCount.js"
	],
	"./AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationCount.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationCount.js"
	],
	"./AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationTextList": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationTextList.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_usefulSection_useGetNotificationTextList_js"
	],
	"./AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationTextList.js": [
		"./src/layouts/AVC_Main/services/sidebarDashboard/usefulSection/useGetNotificationTextList.js",
		"src_layouts_AVC_Main_services_sidebarDashboard_usefulSection_useGetNotificationTextList_js"
	],
	"./MainLayout": [
		"./src/layouts/MainLayout.jsx"
	],
	"./MainLayout.jsx": [
		"./src/layouts/MainLayout.jsx"
	],
	"./useTabNavigation ": [
		"./src/layouts/useTabNavigation .js",
		"src_layouts_useTabNavigation_js"
	],
	"./useTabNavigation .js": [
		"./src/layouts/useTabNavigation .js",
		"src_layouts_useTabNavigation_js"
	],
	"./useUserCheck": [
		"./src/layouts/useUserCheck.js"
	],
	"./useUserCheck.js": [
		"./src/layouts/useUserCheck.js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/layouts lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;